import React from 'react';
import PropTypes from 'prop-types';
import VertCardProductContainer from 'components/VertCardProductContainer/VertCardProductContainer';

export const ShowcaseCard = (props) => {
  const propsCards = {
    ...props,
  };

  return (() => {
    return (
        <VertCardProductContainer
            cardProduct={propsCards}
        />
    );
  })();
};

ShowcaseCard.propTypes = {
  sku: PropTypes.string.isRequired,
  originalId: PropTypes.string.isRequired,
  available: PropTypes.bool,
  availability: PropTypes.object,
  hasExtractValue: PropTypes.bool,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  productUrl: PropTypes.string.isRequired,
  vendorName: PropTypes.string.isRequired,
  vendorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
